<template>
	<div>
		<div class="login-card bg-white px-2 py-2 px-md-4 py-md-4 shadow">
			<div v-if="!authenticated" class="alert alert-danger alert-dismissible fade show shadow-sm" :style="'width: -webkit-fill-available'" role="alert">
				An error occured during Login. <a href="/contact-us?subject=1" class="tx-bold" :style="'color: #721c24'">Contact Us</a>
				<button type="button" class="close" data-dismiss="alert" aria-label="Close">
					<span aria-hidden="true">×</span>
				</button>
			</div>
			<div v-if="loginNotice" class="alert alert-info alert-dismissible fade show wd-100p shadow-sm text-center" role="alert">
				<div v-text="loginNotice"></div>
				<button type="button" class="close" data-dismiss="alert" aria-label="Close">
					<span aria-hidden="true">×</span>
				</button>
			</div>
			<h3 class="tx-color-01">Welcome to our online portal</h3>
			<p class="tx-warning mg-b-30">If you are an existing user of our Tradelive platform, please click Forgotten password? below, to set a new password and gain access to your account.</p>
			<h3 class="tx-color-01">Login</h3>
			<p class="tx-color-03 mg-b-30">Please enter your credentials to continue.</p>
			<form method="POST" action="/login" @submit.prevent="login">
				<div class="form-group">
					<label>Email Address or Phone Number</label>
					<input v-model="form.username" type="text" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('username') }" name="username" placeholder="Enter your email address or phone number" required autofocus />
					<has-error :form="form" :class="'d-block'" :field="username"></has-error>
				</div>
				<div class="form-group">
					<label>Password</label>
					<input v-model="form.password" type="password" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('password') }" name="password" placeholder="Enter your password" required autocomplete="current-password" />
					<has-error :form="form" field="password"></has-error>
				</div>
				<button-component :busy="form.busy" :label="'Sign in'" :label-loading="'Please wait..'" :button-class="'btn btn-default btn-block'"></button-component>
			</form>
			<div class="tx-13 mg-t-40 tx-center">
				<a class="tx-inverse" :href="`/password/reset${resetEmail}`">Forgotten password?</a>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import authentication from '../../mixins/authentication'

export default {
	mixins: [authentication],
	mounted() {
		this.$store.dispatch('clearLocalStorage')
		const { email, targetRoute } = this.$route.query
		this.form.username = email
		this.targetRoute = targetRoute
	},
	data: function () {
		return {
			resetEmail: '',
			authenticated: true,
			username: 'email',
			targetRoute: null,
			form: new Form({
				username: null,
				password: null,
			}),
		}
	},
	created() {
		this.setFeatureFlag('SHOW_LOGIN_NOTICE')
	},
	watch: {
		'form.username': function (value) {
			if (this.isValidEmail(value)) {
				this.resetEmail = `?${value}`
				this.username = 'email'
			} else {
				this.username = 'phone'
			}
		},
	},
	computed: {
		...mapGetters({
			feature: 'featureFlags/feature',
		}),
		loginNotice() {
			const feat = this.feature('SHOW_LOGIN_NOTICE')

			if (feat) {
				const options = feat.options

				return feat.active ? options.message : null
			}

			return false
		},
	},
	methods: {
		...mapActions({
			setFeatureFlag: 'featureFlags/setFeatureFlag',
		}),
		login() {
			this.form.post('/login').then(({ data: { user, token, intended } }) => {
				if (typeof user !== 'undefined') {
					this.$store.dispatch('setLocalStorage', {
						user: JSON.stringify(user),
						token,
					})

					window.location = this.targetRoute ? `/2fa?target=${this.targetRoute}` : intended
					return
				}

				this.authenticated = false
			})
		},
	},
}
</script>

<style>
.login-card {
	width: 30em;
	border-radius: 35px;
}

@media (max-width: 576px) {
	.login-card {
		background-color: transparent !important;
		border-radius: 0rem !important;
		box-shadow: unset !important;
		width: 20em;
	}
}
</style>